
import React from "react";
import { Separator } from "@/components/ui/separator";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/about/HeroSection";
import WhySection from "@/components/about/WhySection";
import HowSection from "@/components/about/HowSection";
import WhatSection from "@/components/about/WhatSection";
import ContactSection from "@/components/about/ContactSection";
import Footer from "@/components/Footer";

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1">
        <HeroSection />
        <WhySection />
        <Separator className="max-w-5xl mx-auto" />
        <HowSection />
        <WhatSection />
        <ContactSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default About;
